(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-server-configurator]');
    if (!root) return;

    var apiUrl = (root.dataset.apiUrl || '').replace(/\/$/, '');
    var productGid = root.dataset.baseProductGid;
    var chassisVariantId = root.dataset.chassisVariantId;
    var chassisName = root.dataset.chassisName;
    var chassisPrice = parseInt(root.dataset.chassisPrice, 10) || 0;

    var i18n = {
      addToCart: root.dataset.i18nAddToCart,
      adding: root.dataset.i18nAdding,
      errorGeneric: root.dataset.i18nErrorGeneric,
      errorNetwork: root.dataset.i18nErrorNetwork,
      success: root.dataset.i18nSuccess,
      quantity: root.dataset.i18nQuantity,
      decrease: root.dataset.i18nDecrease,
      increase: root.dataset.i18nIncrease,
      included: root.dataset.i18nIncluded,
      soldOut: root.dataset.i18nSoldOut,
      summaryTotal: root.dataset.i18nSummaryTotal,
      validating: root.dataset.i18nValidating,
      baseServer: root.dataset.i18nBaseServer,
      categorySelected: root.dataset.i18nCategorySelected,
      ready: root.dataset.i18nReady
    };

    if (!apiUrl || !chassisVariantId) {
      root.innerHTML = '';
      return;
    }

    var config = null;
    var selections = {};
    var resolveTimer = null;
    var resolveRequestId = 0;
    var lastResolve = null;
    var isValidating = false;
    var hasInteracted = false;

    fetch(apiUrl + '/api/public/config?productGid=' + encodeURIComponent(productGid))
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.error) {
          showFatalError(i18n.errorGeneric);
          return;
        }
        config = data;
        applyDefaults();
        renderForm();
        scheduleResolve();
      })
      .catch(function () {
        showFatalError(i18n.errorNetwork);
      });

    function showFatalError(message) {
      root.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'server-configurator__error';
      p.textContent = message;
      root.appendChild(p);
    }

    function applyDefaults() {
      config.categories.forEach(function (category) {
        if (category.maxSelect === 1) {
          var def =
            category.options.filter(function (o) {
              return o.isDefault;
            })[0] ||
            category.options.filter(function (o) {
              return o.available;
            })[0] ||
            category.options[0];
          if (def) {
            selections[category.key] = [{ optionId: def.id, quantity: Math.max(def.minQuantity, 1) }];
          }
        } else if (category.minSelect > 0) {
          // Multi-select categories (e.g. drives) still need a starting
          // selection when at least one is required, or the very first
          // validation check would fail before the customer touches anything.
          var multiDefault = category.options.filter(function (o) {
            return o.isDefault && o.available;
          })[0];
          if (multiDefault) {
            selections[category.key] = [
              { optionId: multiDefault.id, quantity: Math.max(multiDefault.minQuantity, 1) }
            ];
          }
        }
      });
    }

    // ── Rendering ──────────────────────────────────────────

    function renderForm() {
      root.innerHTML = '';
      var wrap = document.createElement('div');
      wrap.className = 'server-configurator__form';

      wrap.appendChild(renderBaseRow());

      config.categories.forEach(function (category, index) {
        wrap.appendChild(renderCategory(category, index));
      });

      wrap.appendChild(renderFooter());

      root.appendChild(wrap);
    }

    function renderBaseRow() {
      var row = document.createElement('div');
      row.className = 'server-configurator__base';

      var info = document.createElement('div');
      var label = document.createElement('p');
      label.className = 'server-configurator__base-label';
      label.textContent = i18n.baseServer;
      var name = document.createElement('p');
      name.className = 'server-configurator__base-name';
      name.textContent = chassisName;
      info.appendChild(label);
      info.appendChild(name);

      var price = document.createElement('span');
      price.className = 'server-configurator__base-price';
      price.textContent = formatPrice(chassisPrice);

      row.appendChild(info);
      row.appendChild(price);
      return row;
    }

    function renderCategory(category, index) {
      var wrapper = document.createElement('div');
      wrapper.className =
        'server-configurator__category' +
        (isCategoryComplete(category) ? ' is-complete' : '');

      var head = document.createElement('div');
      head.className = 'server-configurator__category-head';

      var headingGroup = document.createElement('div');
      headingGroup.className = 'server-configurator__category-heading-group';
      var step = document.createElement('span');
      step.className = 'server-configurator__category-step';
      step.textContent = String(index + 1);
      var heading = document.createElement('h3');
      heading.className = 'server-configurator__category-heading';
      heading.textContent = category.label;
      headingGroup.appendChild(step);
      headingGroup.appendChild(heading);
      head.appendChild(headingGroup);

      var status = document.createElement('span');
      status.className = 'server-configurator__category-status';
      status.textContent = '✓ ' + i18n.categorySelected;
      head.appendChild(status);

      wrapper.appendChild(head);

      if (category.maxSelect === 1) {
        wrapper.appendChild(renderSingleSelectOptions(category));
      } else {
        wrapper.appendChild(renderMultiSelectOptions(category));
      }

      return wrapper;
    }

    function isCategoryComplete(category) {
      var entries = selections[category.key] || [];
      var distinct = {};
      entries.forEach(function (e) {
        if (e.quantity > 0) distinct[e.optionId] = true;
      });
      return Object.keys(distinct).length >= Math.max(category.minSelect, 1);
    }

    function renderSingleSelectOptions(category) {
      var grid = document.createElement('div');
      grid.className = 'server-configurator__options';
      var selected = (selections[category.key] && selections[category.key][0]) || null;

      category.options.forEach(function (option) {
        var isSelected = !!selected && selected.optionId === option.id;

        var card = document.createElement('div');
        card.className =
          'server-configurator__option-card' +
          (isSelected ? ' is-selected' : '') +
          (!option.available ? ' is-disabled' : '');

        var selectLabel = document.createElement('label');
        selectLabel.className = 'server-configurator__option-select';

        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'category-' + category.key;
        radio.value = option.id;
        radio.checked = isSelected;
        radio.disabled = !option.available;
        radio.addEventListener('change', function () {
          hasInteracted = true;
          selections[category.key] = [
            { optionId: option.id, quantity: Math.max(option.minQuantity, 1) }
          ];
          renderForm();
          scheduleResolve();
        });

        var name = document.createElement('span');
        name.className = 'server-configurator__option-name';
        var check = document.createElement('span');
        check.className = 'server-configurator__option-check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        name.appendChild(check);
        name.appendChild(document.createTextNode(option.name));

        var meta = document.createElement('span');
        meta.className = 'server-configurator__option-meta';
        appendPriceOrBadges(meta, option);

        selectLabel.appendChild(radio);
        selectLabel.appendChild(name);
        selectLabel.appendChild(meta);
        card.appendChild(selectLabel);

        if (option.available) {
          card.addEventListener('click', function () {
            if (radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        if (isSelected && optionNeedsStepper(option)) {
          card.appendChild(
            renderQuantityBlock({
              value: selected.quantity,
              min: Math.max(option.minQuantity, 1),
              max: option.maxQuantity,
              ariaLabel: option.name,
              onChange: function (value) {
                hasInteracted = true;
                selections[category.key][0].quantity = value;
                renderForm();
                scheduleResolve();
              }
            })
          );
        }

        grid.appendChild(card);
      });

      return grid;
    }

    function renderMultiSelectOptions(category) {
      var wrap = document.createElement('div');
      wrap.className = 'server-configurator__multi-options';
      var entries = selections[category.key] || [];

      category.options.forEach(function (option) {
        var existing = entries.filter(function (e) {
          return e.optionId === option.id;
        })[0];
        var quantity = existing ? existing.quantity : 0;

        var row = document.createElement('div');
        row.className =
          'server-configurator__multi-row' +
          (quantity > 0 ? ' has-quantity' : '') +
          (!option.available && quantity === 0 ? ' is-disabled' : '');

        var info = document.createElement('div');
        info.className = 'server-configurator__multi-info';
        var name = document.createElement('span');
        name.className = 'server-configurator__option-name';
        name.textContent = option.name;
        var meta = document.createElement('span');
        meta.className = 'server-configurator__option-meta';
        appendPriceOrBadges(meta, option);
        info.appendChild(name);
        info.appendChild(meta);

        row.appendChild(info);
        row.appendChild(
          renderQuantityBlock({
            value: quantity,
            min: 0,
            max: option.available ? option.maxQuantity : 0,
            ariaLabel: option.name,
            onChange: function (value) {
              hasInteracted = true;
              setMultiSelectionQuantity(category.key, option.id, value);
              renderForm();
              scheduleResolve();
            }
          })
        );

        wrap.appendChild(row);
      });

      return wrap;
    }

    function appendPriceOrBadges(container, option) {
      if (option.includedInBase) {
        container.appendChild(renderBadge(i18n.included, 'included'));
      } else if (option.price != null) {
        var price = document.createElement('span');
        price.className = 'server-configurator__option-price';
        price.textContent = formatPrice(option.price);
        container.appendChild(price);
      }
      if (!option.available) {
        container.appendChild(renderBadge(i18n.soldOut, 'sold-out'));
      }
    }

    function renderBadge(text, modifier) {
      var badge = document.createElement('span');
      badge.className = 'server-configurator__badge server-configurator__badge--' + modifier;
      badge.textContent = text;
      return badge;
    }

    function optionNeedsStepper(option) {
      return option.maxQuantity == null || option.maxQuantity > 1;
    }

    function renderQuantityBlock(opts) {
      var block = document.createElement('div');
      block.className = 'server-configurator__option-quantity';

      var label = document.createElement('span');
      label.className = 'server-configurator__option-quantity-label';
      label.textContent = i18n.quantity;
      block.appendChild(label);
      block.appendChild(renderStepper(opts));
      return block;
    }

    function renderStepper(opts) {
      var value = opts.value;
      var min = opts.min;
      var max = opts.max;

      var wrap = document.createElement('div');
      wrap.className = 'server-configurator__stepper';

      var minusBtn = document.createElement('button');
      minusBtn.type = 'button';
      minusBtn.className = 'server-configurator__stepper-btn';
      minusBtn.textContent = '−';
      minusBtn.setAttribute('aria-label', i18n.decrease + ': ' + opts.ariaLabel);
      minusBtn.disabled = value <= min;
      minusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        opts.onChange(Math.max(min, value - 1));
      });

      var valueEl = document.createElement('span');
      valueEl.className = 'server-configurator__stepper-value';
      valueEl.textContent = String(value);

      var plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'server-configurator__stepper-btn';
      plusBtn.textContent = '+';
      plusBtn.setAttribute('aria-label', i18n.increase + ': ' + opts.ariaLabel);
      plusBtn.disabled = max != null && value >= max;
      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        opts.onChange(max != null ? Math.min(max, value + 1) : value + 1);
      });

      wrap.appendChild(minusBtn);
      wrap.appendChild(valueEl);
      wrap.appendChild(plusBtn);
      return wrap;
    }

    function renderFooter() {
      var footer = document.createElement('div');
      footer.className = 'server-configurator__footer';

      var summary = document.createElement('div');
      summary.className = 'server-configurator__summary';
      var summaryLabel = document.createElement('p');
      summaryLabel.className = 'server-configurator__summary-label';
      summaryLabel.textContent = i18n.summaryTotal;
      var summaryValue = document.createElement('p');
      summaryValue.className = 'server-configurator__summary-value';
      summaryValue.textContent = formatPrice(computeTotal());
      var summaryText = document.createElement('div');
      summaryText.appendChild(summaryLabel);
      summaryText.appendChild(summaryValue);
      summary.appendChild(summaryText);

      var validating = document.createElement('p');
      validating.className = 'server-configurator__validating';
      validating.setAttribute('data-configurator-validating', '');
      validating.textContent = i18n.validating;
      validating.hidden = !isValidating;
      summary.appendChild(validating);

      var ready = document.createElement('p');
      ready.className = 'server-configurator__ready';
      ready.setAttribute('data-configurator-ready', '');
      ready.textContent = i18n.ready;
      ready.hidden = isValidating || !(lastResolve && lastResolve.ok);
      summary.appendChild(ready);

      var errorsEl = document.createElement('div');
      errorsEl.className = 'server-configurator__errors';
      errorsEl.setAttribute('data-configurator-errors', '');
      renderErrorsInto(errorsEl);

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--primary server-configurator__submit';
      button.textContent = i18n.addToCart;
      button.disabled = isValidating || !lastResolve || !lastResolve.ok;
      button.setAttribute('data-configurator-submit', '');
      button.addEventListener('click', handleSubmit);

      footer.appendChild(summary);
      footer.appendChild(errorsEl);
      footer.appendChild(button);
      return footer;
    }

    function renderErrorsInto(container) {
      container.innerHTML = '';
      if (!hasInteracted || !lastResolve || lastResolve.ok) return;
      (lastResolve.errors || [i18n.errorGeneric]).forEach(function (message) {
        var p = document.createElement('p');
        p.className = 'server-configurator__error-item';
        p.textContent = message;
        container.appendChild(p);
      });
    }

    // ── State helpers ──────────────────────────────────────

    function setMultiSelectionQuantity(categoryKey, optionId, quantity) {
      var list = selections[categoryKey] || [];
      var existing = null;
      for (var i = 0; i < list.length; i++) {
        if (list[i].optionId === optionId) existing = list[i];
      }
      if (existing) {
        existing.quantity = quantity;
      } else {
        list.push({ optionId: optionId, quantity: quantity });
      }
      selections[categoryKey] = list;
    }

    function flattenSelections() {
      var flat = [];
      Object.keys(selections).forEach(function (categoryKey) {
        selections[categoryKey].forEach(function (entry) {
          if (entry.quantity > 0) {
            flat.push({
              categoryKey: categoryKey,
              optionId: entry.optionId,
              quantity: entry.quantity
            });
          }
        });
      });
      return flat;
    }

    function findOption(optionId) {
      for (var i = 0; i < config.categories.length; i++) {
        var opts = config.categories[i].options;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j].id === optionId) return opts[j];
        }
      }
      return null;
    }

    function computeTotal() {
      var total = chassisPrice;
      flattenSelections().forEach(function (entry) {
        var option = findOption(entry.optionId);
        if (option && option.price != null) total += option.price * entry.quantity;
      });
      return total;
    }

    // ── Server-side validation ─────────────────────────────

    function scheduleResolve() {
      clearTimeout(resolveTimer);
      setValidating(true);
      resolveTimer = setTimeout(resolve, 400);
    }

    function setValidating(value) {
      isValidating = value;
      var el = root.querySelector('[data-configurator-validating]');
      if (el) el.hidden = !value;
      if (value) {
        var readyEl = root.querySelector('[data-configurator-ready]');
        if (readyEl) readyEl.hidden = true;
        var submitBtn = root.querySelector('[data-configurator-submit]');
        if (submitBtn) submitBtn.disabled = true;
      }
    }

    function resolve() {
      var requestId = ++resolveRequestId;
      fetch(apiUrl + '/api/public/resolve', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productGid: productGid, selections: flattenSelections() })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (result) {
          if (requestId !== resolveRequestId) return;
          lastResolve = result;
          setValidating(false);
          var submitBtn = root.querySelector('[data-configurator-submit]');
          if (submitBtn) submitBtn.disabled = !result.ok;
          var readyEl = root.querySelector('[data-configurator-ready]');
          if (readyEl) readyEl.hidden = !result.ok;
          var errorsEl = root.querySelector('[data-configurator-errors]');
          if (errorsEl) renderErrorsInto(errorsEl);
        })
        .catch(function () {
          if (requestId !== resolveRequestId) return;
          lastResolve = { ok: false, errors: [i18n.errorNetwork] };
          setValidating(false);
          var submitBtn = root.querySelector('[data-configurator-submit]');
          if (submitBtn) submitBtn.disabled = true;
          var readyEl = root.querySelector('[data-configurator-ready]');
          if (readyEl) readyEl.hidden = true;
          var errorsEl = root.querySelector('[data-configurator-errors]');
          if (errorsEl) renderErrorsInto(errorsEl);
        });
    }

    function handleSubmit() {
      if (!lastResolve || !lastResolve.ok) return;
      var submitBtn = root.querySelector('[data-configurator-submit]');
      submitBtn.disabled = true;
      submitBtn.textContent = i18n.adding;

      var configId = 'srvcfg-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

      var items = [
        {
          id: chassisVariantId,
          quantity: 1,
          properties: { _config_id: configId, Konfigurasjon: chassisName }
        }
      ].concat(
        lastResolve.lineItems.map(function (li) {
          return {
            id: li.shopifyVariantGid.replace('gid://shopify/ProductVariant/', ''),
            quantity: li.quantity,
            properties: { _config_id: configId, Konfigurasjon: chassisName }
          };
        }),
      );

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          return res.json();
        })
        .then(function () {
          submitBtn.textContent = i18n.success;
          window.location.href = '/cart';
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = i18n.addToCart;
          var errorsEl = root.querySelector('[data-configurator-errors]');
          if (errorsEl) {
            var p = document.createElement('p');
            p.className = 'server-configurator__error-item';
            p.textContent = i18n.errorNetwork;
            errorsEl.appendChild(p);
          }
        });
    }

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('nb-NO', { style: 'currency', currency: 'NOK' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
